import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import axios from "axios";
import { BASE_URL } from "../../constant";

const Sitemap = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/category/all-unhide`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching Categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Get the first five categories
  const firstFiveCategories = categories.slice(0, 5);

  const sitemapData = [
    {
      title: "Products",
      links: firstFiveCategories.map((category) => ({
        name: category.categoryName,
        url: `/shop?category=${category.categoryName.toLowerCase()}`,
      })),
    },
    {
      title: "Customer Service",
      links: [
        { name: "Contact Us", url: "/contact" },
        { name: "FAQs", url: "/faqs" },
        { name: "Shipping Information", url: "/order-history" },
        { name: "Returns & Exchanges", url: "/return-policy" },
      ],
    },
    {
      title: "Company",
      links: [
        { name: "About Us", url: "/about" },
        { name: "Careers", url: "/careers" },
        { name: "Privacy Policy", url: "/privacy-policy" },
        { name: "Terms of Service", url: "/terms-of-use" },
      ],
    },
    {
      title: "My Account",
      links: [
        { name: "Login", url: "/login" },
        { name: "Register", url: "/signup" },
        { name: "Order History", url: "/order-history" },
        { name: "Wishlist", url: "/wishlist" },
      ],
    },
  ];

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />

      <main className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold mb-8 text-center">Site Map</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {sitemapData.map((section, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4 text-gray-800">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.url}
                      className="text-blue-600 hover:text-blue-800 transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Sitemap;
